export default __webpack_public_path__ + "static/media/pencil.4d6d99e8.svg";